import { NgModule } from '@angular/core';
import { ButtonToggleGroupComponent } from './button-toggle-group.component';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  providers: [],
  declarations: [ButtonToggleGroupComponent],
  exports: [ButtonToggleGroupComponent],
})
export class ButtonToggleGroupModule {}
